module.exports = __webpack_public_path__ + "static/aut-int-3bf17bf95ff74cc3a39c43ef28d4d406.png";